import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-unit-log-empty',
  templateUrl: './unit-log-empty.component.html',
  styleUrls: ['./unit-log-empty.component.css']
})
export class UnitLogEmptyComponent {

  
  emptyStateLogs = {
		imgPath: "../../assets/logsheet.svg",
		message1: "Select a Form to view executed and upcoming logs."  
	}
}
